import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    listaUsuariosGrupos: {
      status: false,
      mensagem: ""
    },
    usuarioLogado: false,
    listaUsuarios: [],
    usuariosCarregados: true,
    barraDeProgresso: false, //Barra de progresso para carregar novos usuarios
    desativarSelectOrganizacao: false,
    snackbar: {
      ativo: false,
      mode: "multi-line",
      y: "top",
      timeout: 30000,
      texto: "",
      ativarFechado: true,
      tipo: "success",
    },
    listaPapeis: [
      {
        nome: "Super Administrador",
        valor: "SUPERADMINISTRADOR",
      },
      {
        nome: "Administrador",
        valor: "ADMINISTRADOR",
      },
      {
        nome: "Revendedor",
        valor: "REVENDEDOR",
      },
      {
        nome: "Cliente",
        valor: "CLIENTE",
      },
    ],
    itensMenu: [
      {
        url: "/multiedro",
        nome: "Multiedro",
        liberadoPara: ["SUPERADMINISTRADOR"],
      },
      {
        url: "/clientes",
        nome: "Clientes",
        liberadoPara: ["SUPERADMINISTRADOR", "REVENDEDOR"],
      },
      {
        url: "/usuarios",
        nome: "Usuários",
        liberadoPara: ["SUPERADMINISTRADOR", "REVENDEDOR", "ADMINISTRADOR"],
      },
      {
        url: "/configuracoes",
        nome: "Configurações",
        liberadoPara: ["ADMINISTRADOR"],
      },
      {
        url: "/multisign",
        nome: "Multisign",
        liberadoPara: ["CLIENTE", "ADMINISTRADOR"],
      },
      {
        url: "/agendamentos",
        nome: "Agendamentos",
        liberadoPara: ["CLIENTE", "ADMINISTRADOR"]
      }
    ],
    tagsDaAssinatura: [
      {id:0, nome: "email", value: false, texto: "email"},
      {id: 1, nome: "nome", value: false,  texto: "nome"},
      {id: 2, nome: "cargo", value: false,  texto: "cargo"}, 
      {id: 3, nome: "departamento", value: false,  texto: "departamento"}, 
      {id: 4, nome: "localidade", value: false,  texto: "localidade"}, 
      {id: 5, nome: "telefone", value: false,  texto: "telefone"}, 
      {id: 6, nome: "celular", value: false,  texto: "celular"}, 
      {id: 7, nome: "nome_do_andar", value: false,  texto: "nome do andar"}, 
      {id: 8, nome: "secao_do_andar", value: false,  texto: "secao do andar"}, 
      {id: 9, nome: "codigo_do_funcionario", value: false,  texto: "código do funcionário"}
    ],
    tipoDaTag: {
      nome: "",
      valor: false,
    },
    aplicarAssinatura: {
      id: null,
      path: null,
      tipo: null,
      nome: null
    },
    paginacaoDeUsuarios: {
      grupoId: null,
      tokenPaginacao: null
    },
    mensagemDeErro: "",
    atualizarAssinatura: "",
    idDoTemplate: null,
    editorAssinaturaEstaAtivo: false,
  },
  mutations: {
    sucesso(state, texto) {
      state.snackbar.ativo = true;
      state.snackbar.tipo = "success";
      if (texto == undefined) texto = "Enviado com sucesso!";
      state.snackbar.texto = texto;
    },
    erro(state, texto) {
      state.snackbar.ativo = true;
      state.snackbar.tipo = "error";
      if (texto == undefined) texto = state.mensagemDeErro;
      state.snackbar.texto = texto;
    },
    carregando(state, texto) {
      state.snackbar.ativo = true;
      state.snackbar.tipo = "darkGrey";
      if (texto == undefined) texto = "Carregando...";
      state.snackbar.texto = texto;
    },
    fecharSnackbar(state) {
      state.snackbar.ativo = false;
    },
    ativarLogin(state) {
      state.usuarioLogado = true;
    },
    desativarLogin(state) {
      state.usuarioLogado = false;
    },
    atualizarListaDeUsuarios(context, payload){
     if(payload.length == 0) return this.state.listaUsuarios = [];
      this.state.listaUsuarios.push(...payload);
      return this.state.listaUsuarios;
    },
    fecharListaUsuariosDeGrupo(context, status){
      this.state.listaUsuariosGrupos = status;
    },
    atualizarCheckboxDaTag(context, payload){
      this.state.tipoDaTag = payload;
    },
    atualizarTagsDaAssinatura(context, payload){
      this.state.tagsDaAssinatura.map(tag => {
        if(tag.nome === payload.nome){
          tag.value = payload.status;
        }
      });
      return this.state.tagsDaAssinatura;
    },
    adicionarOrganizacaoOuGrupo(state, payload){
      state.aplicarAssinatura = payload;
    },
    limparDadosDaOrganizacao(state, payload){
      state.organizacao = payload;
    },
    atualizarMensagemDeErro(state, payload){
      state.mensagemDeErro = payload;
    }, 
    atualizarHtmlDaAssinatura(context, payload){
      this.state.atualizarAssinatura = payload
    },
    atualizarIdDoTemplate(state, payload){
      state.idDoTemplate = payload;
    },
    gerenciarBarraDeProgresso(state, payload){
      this.state.barraDeProgresso = payload;
    },
    atualizarPaginaDeUsuarios(state, payload){
      this.state.paginacaoDeUsuarios = payload;
    },
    carregouUsuarios(state, payload){
      this.state.usuariosCarregados = payload;
    },
    desativarComponenteOrganizacao(state, payload){
      this.state.desativarSelectOrganizacao = payload;
    },
    editorAssinaturaEstaAtivo(state, payload){
      this.state.editorAssinaturaEstaAtivo = payload;
    }
  },
  actions: {
    listaUsuariosDoGrupoNoComponente(context, usuario){ 
      context.commit("atualizarListaDeUsuarios", usuario);
    },
    fecharListaDeUsuarios(context, status){
      context.commit("fecharListaUsuariosDeGrupo", status);
    },
    atualizarTag(context, tag){
      context.commit("atualizarCheckboxDaTag", tag)
    },
    filtrarTagDeAssinatura(context, nomeDaTag){
      context.commit("atualizarTagsDaAssinatura", nomeDaTag)
    },
    atualizarConteudoAssinatura(context, html){
      context.commit("atualizarHtmlDaAssinatura", html)
    },
    ativarBarraDeProgresso(context, status){
      context.commit("gerenciarBarraDeProgresso", status);
    },
    paginarUsuarios(context, paginacao){
      context.commit("atualizarPaginaDeUsuarios", paginacao)
    },
    carregouUsuarios(context, carragar){
      context.commit("carregouUsuarios", carragar)
    },
    desativarComponenteOrganizacao(context, status){
      context.commit("desativarComponenteOrganizacao", status);
    },
    desativarEditorAssinatura(context, status){
      context.commit("editorAssinaturaEstaAtivo", status)
    }
  },
  modules: {},
});